angular
  .module 'memberPortal'
  .controller 'MembershipPlansCtrl', (
    $scope,
    $state,
    $stateParams,
    $filter,
    DataService,
    membershipPlans
  ) ->
    $scope.data = DataService
    $scope.membershipPlans = membershipPlans.filter (plan) ->
      !plan.specified_start_date || moment(plan.specified_start_date).isSameOrAfter(moment(), 'day')
    $scope.currency = DataService.currency

    unless DataService.member_details.can_purchase_memberships
      $state.go('memberPortal.bookings', m: $scope.getHash())

    $scope.getHash = ->
      $stateParams.hash || $stateParams.m

    $scope.displayStartDate = (plan) ->
      plan.specified_start_date ||
        plan.default_start_date_strategy in ['start_on_next_upcoming', 'start_relative_to_purchase_date']
